<template>
  <div class="container-fluid preview">
    <header>
      <base  target="_blank"/>
    </header>
    <div class="row text-right" v-if="$store.getters['list/getList']">
      <div class="col">
        <div v-if="$store.getters['list/getVersion']">
          <div class="text-left">
            <br>
            <a :href="/list/ + this.$store.getters['list/getList'] + '/' + this.$store.getters['list/getVersion']"
               class="btn btn-primary">Publish {{this.$store.getters['list/getList'] + ' ' + this.$store.getters['list/getVersion']}} here</a>
          </div>
        </div>
        <div  v-else class="text-left">
          <a :href="/list/ + this.$store.getters['list/getList']" class="btn btn-primary">Publish</a>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h4> {{$store.getters['list/getVersion']}} {{$store.getters['list/getList']}}</h4>
        <br>
        <h3 class="text-left">Categories: </h3>
        <div v-for="category in categoryList" v-bind:key="category">
          <div class="text-left">
            <h5 class="mb-1">{{category}}</h5>
          </div>
        </div>
        <br>
        <div v-for="result in $store.getters['list/getArticles']" v-bind:key="result.guid">
          <div class="card">
            <div class="card-body text-left">
              <h5 style="text-decoration:underline" class="mb-1">Category: {{result.category}}</h5>
              <h5 class="mb-1">{{result.title}}</h5>
              <small v-if="result.pubDate">{{result.pubDate.slice(0,17)}}</small>
              <small v-else>{{result.pubDate}}</small>
              <p class="mb-1" v-html="result.comments"></p>
              <a :href="result.link"> Read More </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import store from '@/store'
import ArticleService from '@/ArticleService'

export default {
  name: 'Preview',
  data: function () {
    return {
      listName: '',
      resultList: [],
      categoryList: [],
      finalList: [],
      versionName: ''
    }
  },
  async created () {
    // console.log(this.$route.params)
    this.listName = this.$store.getters['list/getList']
    this.versionName = this.$store.getters['list/getVersion']
    console.log(this.listName, this.versionName)
    this.resultList = await ArticleService.getbyListandVersion(this.listName, this.versionName)
    console.log(this.resultList)
    this.resultList.forEach(element => {
      // console.log(element.category)
      if (!this.categoryList.includes(element.category)) {
        this.categoryList.push(element.category)
      }
    })
    this.categoryList.sort(function (a, b) {
      if (a !== null && b !== null) {
        if (a.toUpperCase() > b.toUpperCase()) { return 1 }
        if (a.toUpperCase() < b.toUpperCase()) { return -1 }
        return 0
      }
    })
    console.log(this.categoryList)
  }
}
</script>

<style>
/* .current1 {
  background-color: red;
} */

</style>
